export const COUNTER_CREATE = "COUNTER_CREATE";
export const COUNTERS = "COUNTERS";
export const UPDATECOUNTER = "UPDATECOUNTER";
export const DELETECOUNTER = "DELETECOUNTER";

export const COUNTER_TYPE_CREATE = "COUNTER_TYPE_CREATE";
export const COUNTER_TYPES = "COUNTER_TYPES";
export const COUNTER_TYPE_UPDATE = "COUNTER_TYPE_UPDATE";
export const COUNTER_TYPE_DELETE = "COUNTER_TYPE_DELETE";

export const GET_UNITS = "GET_UNITS";

export const createCounter = (data,op) =>{
  return {
    type: COUNTER_CREATE,
    payload:data,
    optype:op
  };
};

export const getCounters = (data,op) =>{
    return {
      type: COUNTERS,
      payload:data,
      optype:op
    };
};

export const updateCounter = data =>{
  return {
    type: UPDATECOUNTER,
    payload:data
  };
};

export const deleteCounter = data =>{
  return {
    type: DELETECOUNTER,
    payload:data
  };
};

export const getUnits = (op) =>{
  return {
    type: GET_UNITS,
    optype:op
  };
};

/* counter types */

export const createCounterType = (data,op) =>{
  return {
    type: COUNTER_TYPE_CREATE,
    payload:data,
    optype:op
  };
};

export const getCounterTypes = (data,op) =>{
  return {
    type: COUNTER_TYPES,
    payload:data,
    optype:op
  };
};